import ButtonReset from './ButtonReset.wrapper';
import { IButtonReset } from './ButtonReset.interfaces';

export default ButtonReset;
export { ButtonReset, IButtonReset };
